/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBluetoothConnected = createReactComponent(
  "bluetooth-connected",
  "IconBluetoothConnected",
  [
    ["path", { d: "M7 8l10 8l-5 4l0 -16l5 4l-10 8", key: "svg-0" }],
    ["path", { d: "M4 12l1 0", key: "svg-1" }],
    ["path", { d: "M18 12l1 0", key: "svg-2" }]
  ]
);

export { IconBluetoothConnected as default };
//# sourceMappingURL=IconBluetoothConnected.js.map
